// LitElement that is a paragraph block
import WarpElement from "@warp-ds/elements-core";
import { AssetFields } from "contentful/dist/types/types/asset.js";
import { css, html, nothing } from "lit";
import { PodletMetaData } from "../../../types/types-drEdition.js";
import { getPodletMetaData, setupCustomElement } from "../../lit-util.js";
import { CurrentPlatform, getCurrentPlatform } from "../utils/getCurrentPlatform.js";

const NAME = "contentful-sponsor-header";

export class ContentfulSponsorHeader extends WarpElement {
	declare entryId: string;
	declare sponsorName: string;
	declare logoImageData: AssetFields;
	declare hideAdTag: boolean;
	declare metaData: PodletMetaData;
	declare currentPlatform: CurrentPlatform;

	static properties = {
		entryId: { type: String },
		sponsorName: { type: String },
		logoImageData: { type: Object },
		hideAdTag: { type: Boolean },
	};

	constructor() {
		super();
		this.entryId = "";
		this.sponsorName = "";
		this.logoImageData = {} as AssetFields;
		this.hideAdTag = false;
		this.metaData = getPodletMetaData();

		this.currentPlatform = {} as CurrentPlatform;
		getCurrentPlatform(this, (currentPlatform) => {
			this.currentPlatform = currentPlatform;
			this.requestUpdate();
		});
	}

	static styles = [
		css`
			* {
				font-family: "Finntype", sans-serif;
			}

			:host {
				display: block;
			}

			.logo-wrapper {
				max-width: 35%;
			}

			@media (max-width: 468px) {
				.logo-wrapper {
					width: 45%;
				}
			}

			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.flex-row-reverse{flex-direction:row-reverse}.gap-10{gap:1rem}.static{position:static}.h-64{height:6.4rem};
		`,
		...WarpElement.styles,
	] as unknown as never;

	render() {
		return html`<aside
			id="sponsor-header"
			class="sponsor-container flex items-center justify-between p-8 h-64 gap-10 ${this.hideAdTag
				? "flex-row-reverse"
				: ""}
				${this.metaData.darkMode ? "dark-mode" : ""}"
		>
			${this.hideAdTag
				? nothing
				: html`<p class="font-bold text-m m-0 ${this.metaData.darkMode ? "s-text-inverted" : "s-text"}">
						${this.i18n.t({
							id: "common.sponsorLabel",
							message: "Annonsørinnhold",
						})}
					</p>`}
			<div class="logo-wrapper">
				<contentful-image
					width="auto"
					fieldId="logoImageData"
					entryId="${this.entryId}"
					.imageData="${this.logoImageData}"
					imageStyle="object-fit: contain; object-position: right; width: auto; max-height: 4.6rem"
				></contentful-image>
			</div>
		</aside>`;
	}
}

setupCustomElement(NAME, ContentfulSponsorHeader);
